import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router  = new VueRouter({
    mode: 'history',
    routes : [
        {
            name      : 'home',
            path      : '/admin',
            meta      : { auth: [ 'admin' ]  },
            component : require('./components/Home.vue').default,
            props     : {
                pageTitle: 'Home',
                nav: {
                    title: 'Home',
                    icon: 'mdi-view-dashboard'
                }
            }
        },

        //Users
        {
            name       : 'users',
            path       : '/admin/users',
            meta       : { auth: [ 'admin' ]  },
            component  : require('./components/users/Users.vue').default,
            props     : {
                pageTitle: 'Users List',
                nav:{
                    title: 'Users',
                    icon: 'mdi-account-supervisor-circle'
                }
            }
        },
        {
            name       : 'user/edit',
            path       : '/admin/user/edit/:id',
            meta       : { auth: [ 'admin' ]  },
            component  : require('./components/users/UserEdit.vue').default,
            props     : (route) => ({
                pageTitle: 'Edit User',
                ...route.params
            })
        },
        {
            name       : 'user/add',
            path       : '/admin/user/add/',
            meta       : { auth: [ 'admin' ]  },
            component  : require('./components/users/UserAdd.vue').default,
            props     : {
                pageTitle: 'Add User',
            }
        },

        //Options
        {
            name      : 'options',
            path      : '/admin/options',
            meta      : { auth: [ 'admin' ] },
            component : require('./components/options/Options.vue').default,
            props     : {
                pageTitle: 'Options',
                nav:{
                    title: 'Options',
                    icon: 'mdi-settings-outline'
                }
            }
        },
    ]
});


export default router;